import {Dispatch, SetStateAction} from "react";

export interface loadedImageType {
    image: (string | ArrayBuffer | null);
    name: any
}

export interface setImageOnUploadProps {
    setNewImages: Dispatch<SetStateAction<loadedImageType[]>>;
    setIsLoading?: SetStateAction<any>;
    setError?: SetStateAction<any>;
}

export default function setImagesOnUpload({setNewImages, setIsLoading, setError}: setImageOnUploadProps) {
    return async (event: any) => {
        const filesList = event?.target?.files;

        const files = Array.from(filesList);

        if (!files.length) return;

        setIsLoading && setIsLoading(true);

        try {
            const imagesPromises = files.map((file: any): any => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(file);

                    reader.addEventListener("load", function () {
                        try {
                            const imagePayload: loadedImageType = {image: reader.result, name: file.name};

                            resolve(imagePayload);
                        } catch(error: any) {
                            reject(error.message);
                        }
                    });

                    reader.addEventListener('error', () => {
                        reject(reader.error);
                    });
                });
            });

            const images = await Promise.all(imagesPromises);

            setNewImages(images);

            setIsLoading && setIsLoading(false);
        } catch (error: any) {
            setIsLoading && setIsLoading(false)

            setError && setError(error.message);
        }
    };
}